/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {AfterViewChecked} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
export class WillyWonka implements AfterViewChecked {
private _chocolate = new Subject<void>();
/**
 * @return {?}
 */
public get chocolate(): Observable<void> {
        return this._chocolate.asObservable();
    }
/**
 * @return {?}
 */
ngAfterViewChecked() {
        this._chocolate.next();
    }
}

function WillyWonka_tsickle_Closure_declarations() {
/** @type {?} */
WillyWonka.prototype._chocolate;
}

